import http from "../../Http/Http-processcommon";
import http2 from "../../Http/Http-processcommon2";
const NombreDelModulo = "congresistaConflictoDeInteres";

class ImportarConflictoInteresesDataService {
    async excel(data){
        return await http.post(`/${NombreDelModulo}/excel`, data);
    }

    async getAllPersonasEnCorpCuatrienio(data){
        return await http.post(`/${NombreDelModulo}/getAllPersonasEnCorpCuatrienio`, data);
    }

    async getPersonaById(id) {
        return await http.get(`/personas/${id}`);
    }

    async totalrecordsPersonasEnCorpCuatrienio(data){
        return await http.post(`/${NombreDelModulo}/totalrecordsPersonasEnCorpCuatrienio`, data);
    }

    async importacion(data){
        return await http.post(`/${NombreDelModulo}/importacion`, data);
    }

    async getPersonaByCongresistaDetalleId(congresista_detalle_id) {
        return await http.get(`/personas/getPersonaByCongresistaDetalleId/${congresista_detalle_id}`);
    }
}

export default new ImportarConflictoInteresesDataService();
